<template>
  <v-data-table
      :loading="loading"
      :items="items"
      :headers="getHeaders"
      :dense="dense"
      disable-pagination
      hide-default-footer
  >
    <template v-slot:item.number="{ item }">
      <order-menu
          :order="item"
          :items="item.items"
          :show-icons="showIcons"
          @showOrder="$emit('showOrder', item)"
          @stateEdited="fetchOrders"
      ></order-menu>
    </template>

    <template v-slot:item.orderType="{ item }">
      <v-btn outlined small :color="orderTypeColor(item)">
        <span class="text-h6">
          {{ orderType(item) }}
        </span>
      </v-btn>

    </template>

    <template v-slot:item.print="{ item }">
      <print-ticket
          :order="item"
          :drink="orderType(item) === 'BEBIDA'"
          :icon="false"
          :class="orderTypeColor(item)"
          class="white--text"
      />
    </template>

    <template v-slot:item.contact.name="{ item }">
      <span class="font-weight-regular">{{ item.contact.name }}</span>
    </template>


    <template v-slot:item.delivery.time="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-chip :class="getAlarmColor(item.delivery.time, item.delivery.date)" v-on="on">
            {{ getTime(item) }}
          </v-chip>
        </template>
        {{ dayjs(item.delivery.dateTime).format("YYYY-MM-DD HH:mm") }}
      </v-tooltip>
    </template>

    <template v-slot:item.actions="{ item }">
      <div class="d-flex">

        <template v-if="orderType(item) === 'BEBIDA'">
          <order-prev-drink-flow-state
              v-if="actionPrev"
              :order="item"
              @orderUpdated="onOrderUpdatedPrev"
          ></order-prev-drink-flow-state>

          <order-next-drink-flow-state
              v-if="actionNext"
              :order="item"
              @orderUpdated="onOrderUpdatedNext"
          />
        </template>

        <template v-else>
          <order-prev-flow-state
              v-if="actionPrev"
              :order="item"
              @orderUpdated="onOrderUpdatedPrev"
          ></order-prev-flow-state>

          <order-next-flow-state
              v-if="actionNext"
              :order="item"
              @orderUpdated="onOrderUpdatedNext"
          />
        </template>


      </div>
    </template>
  </v-data-table>
</template>

<script>
import OrderMenu from "@/modules/delivery/components-core/business/OrderMenu/OrderMenu.vue";
import {DayjsMixin} from "@dracul/dayjs-frontend";
import OrderPrevFlowState from "../OrderPrevFlowState";
import OrderNextFlowState from "@/modules/delivery/components-core/business/OrderNextFlowState";
import OrderProvider from "@/modules/delivery/providers/OrderProvider";
import CurrencyMixin from "@/modules/delivery/mixins/CurrencyMixin";
import dayjs from "dayjs";
import FlowMixin from "@/modules/delivery/mixins/FlowMixin";
import OrderPrevDrinkFlowState
  from "@/modules/delivery/components-core/business/OrderPrevDrinkFlowState/OrderPrevDrinkFlowState.vue";
import OrderNextDrinkFlowState
  from "@/modules/delivery/components-core/business/OrderNextDrinkFlowState/OrderNextDrinkFlowState.vue";
import PrintTicket from "@/modules/delivery/components-core/business/PrintTicket/PrintTicket.vue";

export default {
  name: "OrderFlowWaiterTable",
  props: {
    state: {type: String, required: true},
    drinkState: {type: String},
    disableHeaders: {type: Array, default: () => []},
    dense: {type: Boolean, default: false},
    mode: {type: String},
    showIcons: {type: Boolean, default: true},
    actionPrev: {type: Boolean, default: true},
    actionNext: {type: Boolean, default: true},
    deliveryUserReadOnly: {type: Boolean, default: false},
  },
  components: {
    PrintTicket,
    OrderNextDrinkFlowState,
    OrderPrevDrinkFlowState,
    OrderPrevFlowState,
    OrderNextFlowState,
    OrderMenu,
  },
  mixins: [CurrencyMixin, DayjsMixin, FlowMixin],
  data() {
    return {
      loading: false,
      items: [],
    };
  },
  computed: {
    headers() {
      return [
        {text: this.$t("delivery.print"), value: "print", align: "center", sortable: false},
        {text: this.$t("delivery.order.labels.order"), value: "number"},
        {text: this.$t("delivery.order.labels.name"), value: "contact.name"},
        {text: this.$t("delivery.table"), value: "delivery.table"},
        {
          text: this.$t("delivery.order.labels.type"),
          value: "orderType",
          align: "center",
          sortable: false,
        },
        {text: this.$t("common.actions"), value: "actions", align: "center", sortable: false}
      ];
    },
    getHeaders() {
      return this.headers.filter((h) => !this.disableHeaders.includes(h.value));
    },
    orderType() {
      return order => {
        if (order.drinkState == 'SERVED' && order.state == 'DELIVERED') {
          return 'TODO'
        } else if (order.drinkState == 'SERVED' && order.state == 'READY' && this.state == 'READY') {
          return 'COMIDA'
        } else if (['WAITING', 'SERVED'].includes(order.drinkState)) {
          return 'BEBIDA'
        } else {
          return 'COMIDA'
        }
      }

    },
    orderTypeColor() {
      return order => {
        switch (this.orderType(order)) {
          case 'COMIDA':
            return 'red'
          case 'BEBIDA':
            return 'blue'
          default:
            return 'green'
        }

      }
    }

  },
  created() {
    this.fetchOrders();
  },
  methods: {
    dayjs,
    fetchOrders() {
      this.loading = true;
      OrderProvider.fetchOrdersByState(this.state, null, this.mode, this.drinkState)
          .then((r) => {
            this.items = r.data.orderFetchByState;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.loading = false;
          });
    },

    onOrderUpdatedPrev(order) {
      this.fetchOrders();
      this.$emit("orderUpdatePrev", order);
    },
    onOrderUpdatedNext(order) {
      this.fetchOrders();
      this.$emit("orderUpdateNext", order);
    },
  },
};
</script>

<style scoped></style>
